const packageOfData = [
    {
        "id": "64ae37031e716edb49419ee5",
        "name": "Data Osja Weekly 1",
        "description": "8GB - 60 Mins - 60 SMS",
        "price": "1.00",
        "numberExpried": "string",
        "expired": "22/12/2022",
        "expiredTime": "7 days",
        "renew": false,
        "thumbnail": "string",
        "status": "Success"
    },
    {
        "id": "64ae37341e716edb49419ee6",
        "name": "Data Osja Weekly 1.5",
        "description": "15GB - 100 Mins - 100 SMS",
        "price": "1.50",
        "numberExpried": "string",
        "expired": "22/12/2022",
        "expiredTime": "7 days",
        "renew": true,
        "thumbnail": "string",
        "status": "Failed"
    },
    {
        "id": "64ae377b1e716edb49419ee7",
        "name": "Data Osja Weekly 4",
        "description": "25GB - 5000 Mins - 5000 SMS",
        "price": "4.00",
        "numberExpried": "string",
        "expired": "",
        "expiredTime": "30 days",
        "renew": false,
        "thumbnail": "string",
        "status": "Success"
    },
    {
        "id": "64ae37941e716edb49419ee8",
        "name": "Data Osja Monthly 6",
        "description": "50GB - 5000 Mins - 5000 SMS",
        "price": "6.00",
        "numberExpried": "string",
        "expired": "22/12/2022",
        "expiredTime": "30 days",
        "renew": true,
        "thumbnail": "string",
        "status": "Success"
    }
]

export default packageOfData;
